export default "__VITE_ASSET__b76503c1__"